function Highlight({tags , children}) {
  
  var highlight = children;
  if (Array.isArray(tags)) {
    tags.forEach((el)=>{
      var index = highlight.indexOf(el);
      if (index >= 0) { 
        highlight = highlight.substring(0,index) + `<mark>${highlight.substring(index,index+el.length)}</mark>`+ highlight.substring(index + el.length);
       }
    })
   
  }
  return <span dangerouslySetInnerHTML={{__html : highlight}}></span>
  
}
export default Highlight;